export const makeApiLeadUrl = (): string =>
  `https://app.base44.com/api/apps/68c89c3cdd78df273c3177d4/functions/websiteLead`;